import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './PaperHeader.scss';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage, podlaskieFooterColor, podlaskieLabelBackgroundColor } from '../utils/utils';
import { portalMode } from '../../config';
import { PODLASKIE_MODE } from '../../constants'

class PaperHeader extends Component {
  state = {
    colors: 'normal',
    sourceStyle: headerStyle,
    style: {},
  }

  componentDidMount() {
    this.setColors();
  }

  setColors() {
    const colors = getThemeFromLocalStorage();
    let sourceStyle = headerStyle;
    let style = {
      color: sourceStyle[colors].color,
    };
    if (colors !== 'normal') {
      sourceStyle = headerStyle;
      style = {
        color: sourceStyle[colors].color,
        backgroundColor: sourceStyle[colors].backgroundColor,
      };
    }

    if (portalMode == PODLASKIE_MODE && colors == 'normal') {
      style = {
        color: podlaskieFooterColor,
        backgroundColor: podlaskieLabelBackgroundColor
      };
    }
    this.setState({ colors, sourceStyle, style});
  }

  render() {
    return (
      <div className="title-header" style={this.state.style}>
        <h2 style={{ textAlign: 'center', margin: '0', fontSize: '24px' }}>{this.props.title}</h2>
        {this.props.text && <h3 style={{ textAlign: 'center', margin: '0', fontSize: '12px' }}>{this.props.text}</h3>}
      </div>
    );
  }
}

PaperHeader.propTypes = {
  title: React.PropTypes.string,
  text: React.PropTypes.string,
};

export default withStyles(s)(PaperHeader);



// WEBPACK FOOTER //
// src/components/PaperHeader/PaperHeader.js